import videojs from "!video.js";
import {GuestPlayComponent} from "./components/GuestPlayComponent";
import {FilterComponent} from "./components/FilterComponent";
import {PauseComponent} from "./components/PauseComponent";
import {UserPlayComponent} from "./components/UserPlayComponent";
import {RestartComponent} from "./components/RestartComponent";
import {EndComponent} from "./components/EndComponent";

require('!style-loader!css-loader!video.js/dist/video-js.css')

export default class Player {
    playable;
    vjsPlayer;

    initVideoPlayer(readyCb = null) {
        this.vjsPlayer = videojs('corsi-player', {
            controls: false,
            muted: true,
            autoload: false,
            preload: true,
            loop: true,
            autoplay: false
        })

        this.vjsPlayer.ready(() => {
            this.init()
            
            window.playerInstance = this;
            window.vjsPlayer = this.vjsPlayer;

            window.dispatchEvent(new Event('player:ready'));

            readyCb && typeof readyCb === 'function' ? readyCb.bind(this).apply() : ''
        })
    }

    init() {
        this.registerComponents()
        this.insertInitialActionComponent()
        this.configurePlayable()
        this.customizeOnReady()
    }

    insertInitialActionComponent() {
        this.getVideoSecs(this.getVideoName()).then(seconds => {
            if(seconds) {
                this.addRestartComponent(seconds)

                return
            }
            this.addNewGuestStartComponent()
        })
    }

    registerComponents() {
        this.registerComponent('RestartComponent', RestartComponent)
        this.registerComponent('GuestPlayComponent', GuestPlayComponent)
        this.registerComponent('UserPlayComponent', UserPlayComponent)
        this.registerComponent('PauseComponent', PauseComponent)
        this.registerComponent('EndComponent', EndComponent)
    }

    addRestartComponent(seconds) {
        this.addFilter()
        this.addChildComponent('RestartComponent', {
            playAction: () => this.startPlayer(seconds),
            restartAction: () => this.restartPlayer()
        })
    }
    addEndComponent() {
        this.addFilter()
        this.addChildComponent('EndComponent', {
            restartAction: () => this.restartPlayer()
        })
    }

    restartPlayer() {
        this.removeComponents()
        this.startPlayer(0)
    }

    configurePlayable() {
        this.playable = this.vjsPlayer
    }

    getSource() {
        return this.vjsPlayer.options_['data-src']
    }

    customizeOnReady() {
        this.updatePoster()
        this.updateVideoSrc(this.getSource())
        this.setOnTimeUpdate()
        this.setOnFinished()
        this.currentTime(0)
    }

    updatePoster() {
        const posterUrl = this.vjsPlayer.options_['data-poster_url']

        if (posterUrl) {
            this.vjsPlayer.poster(posterUrl)
        }
    }

    play() {
        this.playable.play()
    }

    pause() {
        this.playable.pause()
    }

    currentTime(seconds = undefined) {
        if (isNaN(seconds)) {
            return this.getCurrentTime()
        }

        this.setCurrentTime(seconds)
    }

    getCurrentTime() {
        return this.playable.currentTime()
    }

    setCurrentTime(seconds) {
        this.playable.currentTime(seconds)
    }

    updateVideoSrc(src) {
        this.playable.src(src)
    }

    setOnTimeUpdate() {
        this.playable.on('timeupdate', () => this.onTimeUpdate(this.currentTime()))
    }

    setOnFinished() {
        this.playable.on('ended', () => {
            const dataType = this.playable.el().getAttribute('data-type');
            if (dataType && dataType === 'questionario-form') {
                this.removeComponents()
                this.addEndComponent()
                this.onFinished()
            }else{
                this.removeComponents()
                this.addRestartComponent(0)
                this.onFinished()
            }
        })
    }

    onFinished() {
        console.log('Player:onFinished')
    }

    onTimeUpdate(seconds) {
        if (this.vjsPlayer.getChild('PauseComponent')) {
            this.setVideoSecs(this.getVideoName(), seconds)
        }
        
        // Controlla se mostrare il CTA in base al timestamp corrente
        this.checkAndShowCta(seconds);
    }
    
    // Nuova funzione per controllare se mostrare il CTA
    checkAndShowCta(seconds) {
        const ctaDelay = window.ctaDelayInSeconds || 0;
        if (seconds >= ctaDelay) {
            const ctaContainer = document.querySelector('.cta_container');
            if (ctaContainer && ctaContainer.classList.contains('d-none')) {
                ctaContainer.classList.remove('d-none');
            }
        }
    }

    getVideoName() {
        return this.vjsPlayer.options_['data-title'];
    }

    addNewGuestStartComponent() {
        this.addFilter()
        this.addChildComponent('GuestPlayComponent', {
            clickAction: () => this.startPlayer(0)
        })
    }

    addUserPlayComponent() {
        this.addFilter()
        this.addChildComponent('UserPlayComponent', {
            clickAction: () => this.playPlayer()
        })
    }

    removeUserStartComponent() {
        this.vjsPlayer.removeChild('UserPlayComponent')
    }

    removeNewGuestStartComponent() {
        this.vjsPlayer.removeChild('GuestPlayComponent')
    }

    removeFilterComponent() {
        this.vjsPlayer.removeChild('FilterComponent')
    }

    removePauseComponent() {
        this.vjsPlayer.removeChild('PauseComponent')
    }
  
    removeEndComponent() {
        this.vjsPlayer.removeChild('EndComponent')
    }

    removeComponents() {
        this.removeUserStartComponent()
        this.removeNewGuestStartComponent()
        this.removeFilterComponent()
        this.removePauseComponent()
        this.removeEndComponent()
    }

    addPauseComponent() {
        this.removeNewGuestStartComponent()
        this.removeUserStartComponent()
        this.removeFilterComponent()
        this.removeRestartComponent()

        this.addChildComponent('PauseComponent', {
            clickAction: () => this.stopPlayer()
        })
    }

    removeRestartComponent() {
        this.vjsPlayer.removeChild('RestartComponent')
    }

    addFilter() {
        this.registerComponent('FilterComponent', FilterComponent)
        this.addChildComponent('FilterComponent')
    }

    startPlayer(seconds = undefined) {
        if (! isNaN(seconds)) {
            this.pause()
            this.currentTime(seconds)
            this.unmute()
        }

        this.addPauseComponent()
        this.play()
    }

    playPlayer() {
        this.addPauseComponent()
        this.play()
    }

    unmute() {
        this.playable.muted(false)
    }

    stopPlayer() {
        this.pause()
        this.removePauseComponent()
        this.addUserPlayComponent()
    }

    setVideoSecs(ckey, cvalue) {
        const cname = `video-sec-${ckey}`
        const exdays = 10;
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    async getVideoSecs(ckey) {
        let cname = `video-sec-${ckey}`
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    registerComponent(componentName, componentClass) {
        videojs.registerComponent(componentName, componentClass)
    }

    addChildComponent(componentName, configs = {}) {
        this.vjsPlayer.addChild(componentName, configs)
    }
}

window.CorsiPlayer = Player